import { Button, Dialog, DialogContent, IconButton, Typography } from '@mui/material';
import { CloseIcon } from '@truvhq/ui';

import fannieProvider from 'assets/images/promo/fannie_provider_logo.png';
import freddieProvider from 'assets/images/promo/freddie_provider_logo.svg';
import iPhone from 'assets/images/promo/iPhone.png';

type Props = {
  href: string;
  onClick: () => void;
  onClose: () => void;
  open: boolean;
};

export const VOAModal = ({ href, onClick, onClose, open }: Props) => {
  return (
    <Dialog
      PaperProps={{
        className: 'z-0 rounded-[32px] max-w-fit',
        sx: {
          '&:before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: -1,
            backgroundColor: '#1F398C',
            backgroundImage: 'linear-gradient(150deg, #2650B7 0%, #162B65 50%, #162B65 70%, #21479F 100%)',
            backgroundPosition: '0 0',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
          },
          '&:after': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: -1,
            backgroundImage: `url("${iPhone}")`,
            backgroundColor: 'transparent',
            backgroundPosition: '50% 100%',
            backgroundRepeat: 'no-repeat',
            backgroundSize: '262px auto',
          },
        },
      }}
      open={open}
      scroll="body"
    >
      <DialogContent className="relative flex min-h-[698px] w-[560px] flex-col items-center text-center">
        <IconButton aria-label="close" className="absolute right-4 top-4 text-white/70" onClick={onClose}>
          <CloseIcon />
        </IconButton>
        <Typography className="mt-10 max-w-[440px] text-[32px] font-medium leading-[105%] text-white">
          Truv Verification of Assets
        </Typography>
        <Typography className="mt-3 max-w-[440px] text-white/60">
          We are an authorized report supplier for Fannie Mae&apos;s Desktop Underwriter® (DU®) validation service and
          an approved support provider of Freddie Mac&apos;s Loan Product Advisor® (LPA℠) asset and income
          modeler&nbsp;(AIM).
        </Typography>
        <Button
          className="mt-6 bg-white text-grey100 hover:bg-white/80 focus:bg-white/80 active:bg-white/80"
          href={href}
          target="_blank"
          variant="contained"
          onClick={onClick}
        >
          Learn more
        </Button>
        <div className="absolute bottom-[250px] right-[82px] flex size-[120px] items-center justify-center rounded-[20px] bg-white shadow-xl">
          <img alt="Fannie Mae certification" height={120} src={fannieProvider} width={120} />
        </div>
        <div className="absolute bottom-[60px] left-[68px] flex size-[120px] items-center justify-center rounded-[20px] border border-grey20/20 bg-white/10 shadow-xl backdrop-blur-xl">
          <img alt="Freddie Mac" src={freddieProvider} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
